import tableRelatedSportRoomPackages from './tableRelatedSportRoomPackages';

export default {
  title: 'V.T. Providers',
  attributeName: 'appPacakges',
  getURL: 'appId/appPackage',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableRelatedSportRoomPackages,
};
